<app-loader></app-loader>
<div class="cancel-booking">
    <div class="find-outer">
        <h4>Spot Count Update</h4>
    </div>
    <div class="parking-reservation">
        <p>{{ nextBillingCycleChecks? confirmationMessage: checkAvalitityData?.message}}</p>
    </div>
    <div *ngIf="nextBillingCycleChecks" class="spot-note">
        <h5><strong>Note: </strong>{{noteMessage}}</h5>
    </div>
    <div class="cancel-outer1">
        <p-button class="mr-2" [label]="nextBillingCycleChecks? 'Yes': 'Confirm'" (onClick)="onConfirm()"></p-button>
        <p-button [label]="nextBillingCycleChecks? 'No':'Cancel'" styleClass="p-button-outlined"
            (onClick)="closeDialog()"></p-button>
    </div>
</div>